<script setup>
import {computed} from 'vue'
import {useFormStore} from '@/stores/form'
import {useUniqueValue} from '@/composables/useUniqueValue'
import InternalLinkBtn from '@/common/InternalLinkBtn'

const props = defineProps({
    formId: String,
    field: Object,
    value: [String, Number, Date] // Added to support the watch target inside the composable
})

// Initialize Vue 3 style composable logic (No DOM ref needed as InternalLinkBtn wraps the value)
useUniqueValue(props)

// Pinia Store
const formStore = computed(() => props.formId ? useFormStore(props.formId) : null)

// Computed properties
const currentData = computed(() => {
    return formStore.value?.currentData
})

const tableName = computed(() => {
    return formStore.value?.tableName
})

const removeDisabledBtn = computed(() => {
    // Prevent the content::pageId field from being unset
    return tableName.value === 'content' && props.field.name === 'pageId'
})

const selectContentMode = computed(() => {
    return !!props.field.targetContent
})

// Methods
const onChange = (id) => {
    if (currentData.value) {
        currentData.value[props.field.name] = id
    }
}

// Emulating the created hook logic
formStore.value?.setDefaultValue({
    name: props.field.name,
    value: 0
})
</script>

<template>
    <div>
        <InternalLinkBtn :id="currentData ? currentData[field.name] : undefined" :field="field" :form-id="formId"
                         :select-content-mode="selectContentMode" :on-change="onChange"
                         :remove-disabled-btn="removeDisabledBtn"/>
    </div>
</template>